/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.EmailQueue {

    @Serenity.Decorators.panel()
    export class EmailQueueDialog extends NoboxEntityDialog<EmailQueueRow, any> {
        protected getFormKey() { return EmailQueueForm.formKey; }
        protected getIdProperty() { return EmailQueueRow.idProperty; }
        protected getLocalTextPrefix() { return EmailQueueRow.localTextPrefix; }
        protected getNameProperty() { return EmailQueueRow.nameProperty; }
        protected getDeletePermission() { return EmailQueueRow.deletePermission; }
        protected getInsertPermission() { return EmailQueueRow.insertPermission; }
        protected getUpdatePermission() { return EmailQueueRow.updatePermission; }
        protected getService() { return EmailQueueService.baseUrl; }

        protected form = new EmailQueueForm(this.idPrefix);
        constructor() {
            super();

            
            //this.form.Status.changeSelect2(e => {
            //    if (this.form.Status.value == EmailQueue.EmailQueueStatus.InQueue) {
            //        this.form.RetryCount.value = 0;
            //        this.form.LockExpiration.valueAsDate = new Date();
            //    }
            //});
        }
        protected updateInterface() {
            super.updateInterface();
            var set = JSON.parse(this.get_entity().Settings);
            this.showSMTP(set.Account.IsSMTP, set.Account.Channel);
            var $form = this.form;
            Serenity.EditorUtils.setValue($form.IsSMTP, set.Account.IsSMTP);
            if (set.Account.IsSMTP == "API") {
                Serenity.EditorUtils.setValue($form.Provider, set.Account.Provider);
                Serenity.EditorUtils.setValue($form.BaseUrlApi, set.Account.BaseUrlApi);
                Serenity.EditorUtils.setValue($form.EndpointApi, set.Account.EndpointApi);
                Serenity.EditorUtils.setValue($form.KeyApi, set.Account.KeyApi);
                Serenity.EditorUtils.setValue($form.FromApi, set.Account.FromApi);
            } else {
                Serenity.EditorUtils.setValue($form.Host, set.Account.Host);
                Serenity.EditorUtils.setValue($form.Port, set.Account.Port);
                Serenity.EditorUtils.setValue($form.UseSSL, set.Account.UseSSL);
                Serenity.EditorUtils.setValue($form.From, set.Account.From);
                Serenity.EditorUtils.setValue($form.Username, set.Account.Username);
                Serenity.EditorUtils.setValue($form.Password, set.Account.Password);
            }
        }
        protected showSMTP(issmtp, chid) {
            var $form = this.form;
            //SMTP
            var value = issmtp == "SMTP" && chid == "19" ? true : false;
            $form.Host.getGridField().toggle(value);
            $form.Port.getGridField().toggle(value);
            $form.UseSSL.getGridField().toggle(value);
            $form.From.getGridField().toggle(value);
            $form.Username.getGridField().toggle(value);
            $form.Password.getGridField().toggle(value);

            //API
            value = issmtp == "API" && chid == "19" ? true : false;
            $form.EndpointApi.getGridField().toggle(value);
            $form.Provider.getGridField().toggle(value);
            $form.BaseUrlApi.getGridField().toggle(value);
            $form.KeyApi.getGridField().toggle(value);
            $form.FromApi.getGridField().toggle(value);
        }
    }
}